import { service } from '@/utils/request'

export default {
	// 查询
	getList(params) {
		return service({
			url: '/cloud/course/v1/subject/list',
			method: 'get',
			params
		})
	},
	// 创建
	create(data) {
		return service({
			url: '/cloud/course/v1/subject/create',
			method: 'post',
			data: data
		})
	},
	// 更新
	update(data) {
		return service({
			url: '/cloud/course/v1/subject/update',
			method: 'post',
			data: data
		})
	},
	// 删除
	delete(id) {
		return service({
			url: '/cloud/course/v1/subject/delete/' + id,
			method: 'post'
		})
	},
}



// WEBPACK FOOTER //
// ./src/api/contentManage/courseColumn.js